import styles from './SplitPageLayout.module.scss';

/**
 * SplitPageLayout 컴포넌트
 * - 좌우로 분할된 레이아웃을 제공하는 공통 컴포넌트
 * - 좌측에는 리스트/테이블, 우측에는 상세 정보를 표시할 때 사용
 *
 * @param {React.ReactNode} leftChildren - 좌측 패널에 표시할 내용
 * @param {React.ReactNode} rightChildren - 우측 패널에 표시할 내용
 * @param {string} leftWidth - 좌측 패널 너비 (기본값: '70%')
 * @param {string} rightWidth - 우측 패널 너비 (기본값: '30%')
 * @param {string} height - 전체 레이아웃 높이 (기본값: 'calc(100vh - 200px)')
 * @param {string} className - 추가 클래스명
 *
 * @example
 * // 기본 사용법 (70:30 비율)
 * <SplitPageLayout
 *   leftChildren={<div>좌측 내용</div>}
 *   rightChildren={<div>우측 내용</div>}
 * />
 *
 * @example
 * // 커스텀 비율 사용 (60:40)
 * <SplitPageLayout
 *   leftChildren={<div>좌측 내용</div>}
 *   rightChildren={<div>우측 내용</div>}
 *   leftWidth="60%"
 *   rightWidth="40%"
 * />
 *
 * @example
 * // 높이 커스터마이징
 * <SplitPageLayout
 *   leftChildren={<div>좌측 내용</div>}
 *   rightChildren={<div>우측 내용</div>}
 *   height="800px"
 * />
 */
export default function SplitPageLayout({
  leftChildren,
  rightChildren,
  leftWidth = '70%',
  rightWidth = '30%',
  height = 'calc(100vh - 200px)',
  className,
}) {
  const containerClassName = className ? `${styles.splitLayout} ${className}` : styles.splitLayout;

  const containerStyle = {
    height,
  };

  const leftPanelStyle = {
    flex: `1 1 ${leftWidth}`,
  };

  const rightPanelStyle = {
    flex: `1 1 ${rightWidth}`,
  };
  return (
    <div className={containerClassName} style={containerStyle}>
      {/* 좌측 패널 */}
      <div className={styles.leftPanel} style={leftPanelStyle}>
        {leftChildren}
      </div>

      {/* 우측 패널 */}
      <div className={styles.rightPanel} style={rightPanelStyle}>
        {rightChildren}
      </div>
    </div>
  );
}
